<template>
  <v-container fluid class="ma-0 pa-0">
    <v-autocomplete
      :value="selectedStores"
      :items="stores"
      item-text="name"
      item-value="store_party_id"
      item-color="action"
      label="Stores"
      :loading="loading"
      :search-input.sync="storeSearch"
      background-color="input"
      :placeholder="(isAdmin || isARGAdmin) ? 'Start typing to search' : null"
      hide-no-data
      hide-details
      multiple
      cache-items
      return-object
      small-chips
      deletable-chips
      dense
      outlined
      @change="$emit('update:selectedStores', $event)">
      <template v-slot:item="{ item, attrs, on }">
        <v-list-item
          v-bind="attrs"
          color="action"
          v-on="on">
          <v-list-item-content>
            <v-list-item-title>
              {{ item.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.party_type_name }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </v-container>
</template>
  
<script>
import Search from '@/axios/search-endpoint'
// mixins
import { userAccess } from '@/mixins/user-access'
import { displayAlert } from '@/mixins/alert'
// third-party
import { debounce } from 'lodash'

export default {
  data() {
    return {
      stores: [],
      storeSearch: '',
      loading: false
    }
  },
  name: 'StoreSelect',
  mixins: [userAccess, displayAlert],
  props: {
    selectedStores: Array
  },
  watch: {
     storeSearch: {
      handler: debounce(function (newValue) {
        if (this.searchEnabled && newValue) {
          this.searchStores()
        }
      }, 500)
    },
    selectedStores: {
      handler (newValue) {
        if (newValue && newValue.length > 0) {
          this.initStores()
        }
      },
      deep: true
    },
    userRelatedParties: {
      handler (newValue) {
        if (newValue && newValue.length > 0 && this.limitAccessByRelatedStores) {
          this.stores.push(...this.userDropdownParties)
        }
      },
      deep: true
    },
  },
  created() {
    if (this.selectedStores.length > 0) {
      this.initStores()
    }
    if (this.limitAccessByRelatedStores && this.userRelatedParties.length > 0) {
      this.stores.push(...this.userDropdownParties)
    }
  },
  computed: {
    userDropdownParties () {
      return this.relatedStoreParties.flatMap(store => this.formatParty(store))
    },
    searchEnabled () {
      return !this.limitAccessByRelatedStores
    },

  },
  methods: {
    initStores () {
      this.stores = [...this.selectedStores]
    },
    async searchStores () {
      if (this.limitAccessByRelatedStores && this.relatedStoreParties.length === 0) return
      if (this.storeSearch) this.loading = true
      const term = this.storeSearch || ''
      let stores = []
      try {
        const res = await Search.customerSearch(term, 'and')
        if (res && res.data && res.data.length > 0) {
          stores = res.data.flatMap(party => {
            return (party.party_type) === 'STORE'
              ? this.formatParty(party)
              : []
          })
        }
        this.stores = [...this.stores, ...stores]
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    
    formatParty(party) {
      let display_name = party.party_name || party.name
      const partyType = party.party_type_constant || party.party_type
      if (party.attributes) {
        const attrVal = party.attributes.WHOLESALER_STORE_NUMBER || ''
        display_name = `${attrVal} ${display_name}`
      }
      party.name = display_name
      party.party_type_name = this.formatPartyType(partyType)
      if (!party.id) {
        party.id = party.party_id
      }
      return party
    },
    formatPartyType (str) {
      str = str.toLowerCase().replaceAll('_', ' ')
      const parts = str.split(' ').map(part => part.charAt(0).toUpperCase() + part.slice(1))
      return parts.join(' ')
    }
  }
}
</script>
